/**
 * 模組頁面代碼 : 1330-UI-01
 * 頁面說明 : 住戶清單列表頁面
 * @module modules/resident/components/ResidentPage
 */

// ----- import from npm modules -----
import $ from 'jquery';

// ----- import from base libraries -----
import {
    React,
    PropTypes,
    BaseComponent,
    connect,
    AccessModeEnums,
    ModuleEnums,
} from '../../../components/BaseComponent';
import {
    DataTableComponent,
    batchCheckControls,
} from '../../../components/CommonComponent';

import { AlertModalModeEnums } from 'web/components/AlertModal';
import Breadcrumb from '../../../features/main-frame/components/Breadcrumb';

class ResidentPage extends BaseComponent {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
        this.state = {
            searchBuildingId: '',
            searchHouseNum: '',
            searchElevatorId: '',
            searchFloorDisplay: '',
            elevatorList: null,
            floorList: null,
        };
        this.setSearchBuildingId = this.setSearchBuildingId.bind(this);
        this.setSearchHouseNum = this.setSearchHouseNum.bind(this);
        this.setSearchElevatorId = this.setSearchElevatorId.bind(this);
        this.setSearchFloorDisplay = this.setSearchFloorDisplay.bind(this);
        this.setElevatorList = this.setElevatorList.bind(this);
        this.setFloorList = this.setFloorList.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.prepareResidentTable = this.prepareResidentTable.bind(this);
        this.addEventListeners = this.addEventListeners.bind(this);
        this.onBatchHandle = this.onBatchHandle.bind(this);
    }

    setSearchBuildingId(searchBuildingId) {
        this.setState({ searchBuildingId: searchBuildingId });
    }

    setSearchHouseNum(searchHouseNum) {
        this.setState({ searchHouseNum: searchHouseNum });
    }

    setSearchElevatorId(searchElevatorId) {
        this.setState({ searchElevatorId: searchElevatorId });
    }

    setSearchFloorDisplay(searchFloorDisplay) {
        this.setState({ searchFloorDisplay: searchFloorDisplay});
    }

    setElevatorList(elevatorList) {
        this.setState({ elevatorList: elevatorList });
    }

    setFloorList(floorList) {
        this.setState({ floorList: floorList });
    }

    // Handle change event
    handleChange = (event) => {
        const target = event.target;
        let value = target.value;

        // 當選擇大樓時，要更新電梯選項
        if (target.id === 'searchBuildingSelection') {
            const buildingId = parseInt(value);
            this.setSearchBuildingId(buildingId);
            const building = this.props.buildingSelection.find(building => building.buildingId === buildingId);
            const elevatorList = building !== null && building !== undefined ? building.elevators : [];
            this.setState({ elevatorList });
            if (elevatorList.length > 0) {
                const floorList = elevatorList[0].floors;
                this.setState({ floorList });
            }
        }

        // 當選擇電梯編號時，要更新樓層選項
        if (target.id === 'searchElevatorSelection') {
            const elevatorId = parseInt(value);
            const buildingId = parseInt(this.state.searchBuildingId);
            this.setSearchElevatorId(elevatorId);
            const building = this.props.buildingSelection.find(building => building.buildingId === buildingId);
            if (building !== null && building !== undefined) {
                const elevator = building?.elevators.find(elevator => elevator.elevatorId === elevatorId);
                const floorList = elevator !== null && elevator !== undefined ? elevator.floors : [];
                this.setState({ floorList });
            } else {
                this.setState({ floorList: [] });
            }
        }
    };

    prepareResidentTable = () => {
        const { residentList } = this.props;

        // 定義資料內容
        const dataSet = residentList.map((applicant) => {
            const resident = applicant.resident;
            const elevatorNums = applicant.elevatorNums.join(', ');
            return [
                resident.buildingName,
                elevatorNums,
                applicant.applicantName,
                applicant.mobile,
                resident.houseNum,
                resident.floorDisplay,
                resident.roomNum,
                applicant.flgStatus,
                applicant.updateTime,
            ];
        });

        // 定義欄位屬性
        const columnConfig = [
            {
                orderable: false,
                order: null,
                title: '<div class="form-check"><input class="form-check-input" type="checkbox" value="" id="check-all" data-show-indeterminate="true"/><label class="form-check-label" for="check-all"></label></div>',
                data: null,
                render: function (data, type, row, meta) {
                    let checkboxId = 'cks-resident-' + meta.row;
                    return `
                        <div class="form-check">
                            <input class="form-check-input item-cks-resident" type="checkbox" value="" id="${checkboxId}" name="cks" />
                            <label class="form-check-label" for="${checkboxId}"></label>
                        </div>
                    `;
                },
                width: '5%',
            },
            { title: '大樓名稱', className: 'dt-center', data: 0 },
            { title: '電梯編號', className: 'dt-center', data: 1 },
            { title: '住戶', className: 'dt-center', data: 2 },
            { title: '手機號碼', className: 'dt-center', data: 3 },
            { title: '戶號', className: 'dt-center', data: 4 },
            { title: '樓層', className: 'dt-center', data: 5 },
            { title: '室號', className: 'dt-center', data: 6 },
            {
                title: '狀態',
                className: 'dt-center',
                data: 7,
                render: function (data, type, row, meta) {
                    // Mapping of codes to labels and class names
                    const statusMapping = {
                        A: { label: '有效', className: 'badge bg-dark-green text-light fw-bold fs-7' },
                        I: { label: '無效', className: 'badge bg-dark-red text-light fw-bold fs-7' },
                        B: { label: '黑名單', className: 'badge bg-black text-light fw-bold fs-7' },
                    }

                    // Get the corresponding label and class name based on the data
                    const statusInfo = statusMapping[data] || { label: data, className: 'badge bg-light text-dark fw-bold fs-7' }

                    // Return an HTML string with the label and class name
                    return `<span class="${statusInfo.className}" style="white-space:nowrap;">${statusInfo.label}</span>`
                },
                width: '8%',
            },
            { title: '修改時間', className: 'dt-head-center', data: 8, render: DataTable.render.datetime('YYYY-MM-DD HH:mm:ss'), type: 'datetime' },
            {
                orderable: false,
                order: null,
                title: '啟用',
                data: 7,
                className: 'dt-center',
                render: (data, type, row, meta) => {
                    let enableId = 'eab-resident-' + meta.row;
                    let isChecked = data === 'A' ? 'checked' : '';
                    let enableButton = this.checkPermission(ModuleEnums.RESIDENT, AccessModeEnums.DELETE) && data !== 'B' ? '' : 'disabled';
                    return `<div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch" id="${enableId}" ${isChecked} ${enableButton} />
                                <label class="form-check-label" for="${enableId}"></label>
                            </div>`;
                },
            },
            {
                orderable: false,
                order: null,
                data: null,
                className: 'dt-right',
                render: (data, type, row, meta) => {
                    let resetPasswordId = 'reset-password-' + meta.row;
                    let resetVenderId = 'reset-vender-' + meta.row;
                    let editId = 'edit-resident-' + meta.row;
                    let resetPasswordButton = this.checkPermission(ModuleEnums.RESIDENT, AccessModeEnums.UPDATE) ?
                        `<button type="button" class="btn btn-sm btn-link" id="${resetPasswordId}">
                            重設密碼
                        </button>` : '';
                    let resetVenderButton = this.checkPermission(ModuleEnums.RESIDENT, AccessModeEnums.UPDATE) ?
                        `<button type="button" class="btn btn-sm btn-link" id="${resetVenderId}">
                            重設手機驗證
                        </button>` : '';
                    let updateButton = this.checkPermission(ModuleEnums.RESIDENT, AccessModeEnums.UPDATE) ?
                        `<button type="button" class="btn btn-sm btn-link" id="${editId}">
                            <svg class="btn__icon btn__icon--sm me-1" aria-hidden="true">
                                <use href="#ico-edit"></use>
                            </svg>
                            修改
                        </button>` : '';
                    return `
                        <div class="btn-group" role="group" aria-label="">
                            ${resetPasswordButton}
                            ${resetVenderButton}
                            ${updateButton}
                        </div>`;
                },
            },
        ];

        // 定義排序設定
        const orderConfig = {
            idx: 8,
            dir: 'dsc',
        };

        // 定義固定欄位設定
        const fixedColumnsConfig = {
            start: 1,
        };

        // 先清除datatable
        if ($.fn.DataTable.isDataTable('#datatable__residentList')) {
            $('#datatable__residentList').DataTable().destroy();
        }

        // 重新繪製datatable
        DataTableComponent('#datatable__residentList', dataSet, columnConfig, orderConfig, fixedColumnsConfig, true, true);
        this.addEventListeners();
        batchCheckControls();
    }

    componentDidMount() {
        // 檢查權限
        this.checkPermission(ModuleEnums.RESIDENT, AccessModeEnums.READ);
    }

    componentDidUpdate(prevProps) {
        const { needResidentListLoad, setNeedResidentListLoad, residentList } = this.props;
        if (needResidentListLoad && 
            needResidentListLoad !== prevProps.needResidentListLoad) {
            if (residentList.length > 0) {
                this.prepareResidentTable();
            }
            setNeedResidentListLoad(false);
        }
    }

    handleSearch(e) {
        e.preventDefault();
        const searchForm = new FormData(e.target);
        const buildingId = parseInt(searchForm.get('searchBuildingSelection')? searchForm.get('searchBuildingSelection') : 0);
        const houseNum =searchForm.get('searchHouseNum');
        const elevatorId = parseInt(searchForm.get('searchElevatorSelection')? searchForm.get('searchElevatorSelection') : 0);
        const floorDisplay = searchForm.get('searchFloorSelection')? searchForm.get('searchFloorSelection') : '';
        this.props.setSearchResident(buildingId, houseNum, elevatorId, floorDisplay);
        this.props.fetchResidentList(buildingId, houseNum, elevatorId, floorDisplay).then(() => {
            // Get data and redraw datatable
            this.prepareResidentTable();
        });
    }

    addEventListeners() {
        if (this.tableRef.current) {
            this.tableRef.current.addEventListener('click', (event) => {
                const button = event.target.closest('.btn');
                const index = button && parseInt(button.id.split('-')[2]);
                const applicantId = index !== null && index !== undefined ? this.props.residentList[index].applicantId : null;
                const applicantName = index !== null && index !== undefined ? this.props.residentList[index].applicantName : null;
                if (button && button.id.startsWith('reset-password-')) {
                    const message = `重設 [ ${applicantName} ] 的密碼`;
                    const memo = '重新設定為預設密碼(與帳號相同)，請於系統重設密碼後提醒使用者在手機APP中修改新密碼。';
                    this.props.onResetPassword(AlertModalModeEnums.RESETPASSWORD, message, memo, applicantId);
                }
                if (button && button.id.startsWith('reset-vender-')) {
                    const message = `重設 [ ${applicantName} ] 的手機驗證碼`;
                    const memo = '重新設定手機驗證，請於系統重設後提醒使用者重新於手機APP登入後才能完成手機驗證作業。';
                    this.props.onResetVenderId(AlertModalModeEnums.RESETVENDERID, message, memo, applicantId);
                }
                if (button && button.id.startsWith('edit-resident-')) {
                    this.props.onEditResident(parseInt(button.id.split('-')[2]));
                }
            });
        }
        this.tableRef.current.addEventListener('change', (event) => {
            const checkbox = event.target.closest('input[type="checkbox"]');
            if (checkbox && checkbox.id.startsWith('eab-resident-')) {
                const index = parseInt(checkbox.id.split('-')[2]);
                const mode = checkbox.checked ? AlertModalModeEnums.ENABLE : AlertModalModeEnums.DISABLE;
                const updateResident = this.props.residentList[index];
                if (updateResident) {
                    let message = '';
                    if (mode === AlertModalModeEnums.ENABLE) {
                        message = `啟用 [ ${updateResident.applicantName}) ] 的帳號`;
                    } else {
                        message = `停用 [ ${updateResident.applicantName}) ] 的帳號`;
                    }
                    this.props.onEditResidentStatus(mode, message, updateResident.applicantId);
                } else {
                    console.log('No resident found at index:', index);
                }
            }
        });
    }

    onBatchHandle(mode = AlertModalModeEnums.DELETE) {
        const applicantIds = [];
        const checkboxes = document.querySelectorAll('.item-cks-resident');
        checkboxes.forEach((checkbox) => {
            if (checkbox.checked) {
                const applicantId = this.props.residentList[parseInt(checkbox.id.split('-')[2])].applicantId;
                applicantIds.push(applicantId);
            }
        });
        // 如果沒有選擇任何資料就不處理
        if (applicantIds.length === 0) {
            return;
        }

        this.props.onBatchHandle(mode, applicantIds);      
    }

    render() {
        const { buildingSelection, onNewResident, onImportData } = this.props;
        return (
            <section id="datatable-container">
                <Breadcrumb categoryName="系統設定" pageName="住戶資料" />
                <h4>住戶資料</h4>
                <div className="datatable__search">
                    <form className="d-flex gap-2 align-items-end needs-validation" onSubmit={this.handleSearch}>
                        <div className="flex-fill w-100">
                            <label htmlFor="searchBuildingSelection" className="form-label">大樓名稱*</label>
                            <select
                                className="form-select form-select-sm"
                                id="searchBuildingSelection"
                                name="searchBuildingSelection"
                                value={this.state.searchBuildingId}
                                onChange={this.handleChange}
                                required>
                                    <option disabled value="">請選擇</option>
                                    <option value="0">全部</option>
                                    {buildingSelection.map((building, index) => (
                                        <option key={index} value={building.buildingId}>{building.buildingName}</option>
                                    ))}
                            </select>
                        </div>
                        <div className="flex-fill w-100">
                            <label htmlFor="searchHouseNum" className="form-label">戶號</label>
                            <input type="text" className="form-control form-control-sm" id="searchHouseNum" name="searchHouseNum" value={this.state.searchHouseNum} onChange={e => this.setSearchHouseNum(e.target.value)} />
                        </div>
                        <div className="flex-fill w-100">
                            <label htmlFor="searchElevatorSelection" className="form-label">電梯編號</label>
                            <select
                                className="form-select form-select-sm"
                                id="searchElevatorSelection"
                                name="searchElevatorSelection"
                                value={this.state.searchElevatorId}
                                onChange={this.handleChange}
                            >
                                <option disabled value="">請選擇</option>
                                <option value="0">全部</option>
                                {this.state.elevatorList && this.state.elevatorList.map((elevator, index) => (
                                    <option key={index} value={elevator.elevatorId}>{elevator.elevatorName}</option>
                                ))}
                            </select>
                        </div>
                        <div className="flex-fill w-100">
                            <label htmlFor="searchFloorSelection" className="form-label">樓層</label>
                            <select
                                className="form-select form-select-sm"
                                id="searchFloorSelection"
                                name="searchFloorSelection"
                                value={this.state.searchFloorDisplay}
                                onChange={e => this.setSearchFloorDisplay(e.target.value)}>
                                <option disabled value="">請選擇</option>
                                <option value="">全部</option>
                                {this.state.floorList && this.state.floorList.map((floor, index) => (
                                    <option key={index} value={floor.floorDisplay}>{floor.floorDisplay}</option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <button className="btn btn-primary" type="submit" aria-label="搜尋">
                                <svg className="btn__icon" aria-hidden="true">
                                    <use href="#ico-search"></use>
                                </svg>
                            </button>
                        </div>
                    </form>
                </div>
                <div className="datatable__tool">
                    <div className="d-flex align-items-center gap-2">
                        <div className="datatable__tool__label">
                            多筆選擇
                            <div id="checked-count-display"></div>
                        </div>
                        <div className="btn-group btn-group-sm" role="group" aria-label="">
                            {this.checkPermission(ModuleEnums.RESIDENT, AccessModeEnums.DELETE) && (
                                <button type="button" className="btn btn-outline-secondary btn-batch" aria-label="啟用" id="btnBatchEnable" onClick={() => this.onBatchHandle(AlertModalModeEnums.ENABLE)}>啟用</button>
                            )}
                            {this.checkPermission(ModuleEnums.RESIDENT, AccessModeEnums.DELETE) && (
                                <button type="button" className="btn btn-outline-secondary btn-batch" aria-label="停用" id="btnBatchDisable" onClick={() => this.onBatchHandle(AlertModalModeEnums.DISABLE)}>停用</button>
                            )}
                        </div>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                        {this.checkPermission(ModuleEnums.RESIDENT, AccessModeEnums.CREATE) && (
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-primary"
                                aria-label="匯入"
                                id="modalImportBtn"
                                onClick={onImportData}
                                data-bs-toggle="modal"
                                data-bs-target="#modalImport"
                            >
                                <svg className="btn__icon me-2" aria-hidden="true">
                                    <use href="#ico-download"></use>
                                </svg>
                                匯入
                            </button>
                        )}
                        {this.checkPermission(ModuleEnums.RESIDENT, AccessModeEnums.CREATE) && (
                            <button type="button" className="btn btn-sm btn-primary" aria-label="新增" id="modalResidentBtnNew" onClick={onNewResident}>
                                <svg className="btn__icon me-2" aria-hidden="true">
                                    <use href="#ico-plus"></use>
                                </svg>
                                新增
                            </button>
                        )}
                    </div>
                </div>
                <div className="datatable__data" ref={this.tableRef}>
                    <table id="datatable__residentList" className="display table table-hover align-middle nowrap"></table>
                </div>
            </section>
        );
    }
}

ResidentPage.propTypes = {
};

ResidentPage.defaultProps = {
};

const mapStateToProps = (state) => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResidentPage);